export const servicios = {
    text1: "قائمة طلبات الخدمات",
    text2: "الطلبات التي قدّمها عملاؤك",
    text3: "قائمة الطلبات",
    text4: "الكل",
    text5: "معلّق",
    text6: "مقبول",
    text7: "مرفوض",
    text8: "مدفوع",
    text9: "الخدمة",
    text10: "العميل",
    text11: "الهاتف",
    text12: "تاريخ الإنشاء",
    text13: "الحالة",
    text14: "عرض الطلب",
    text15: "طلب خدمة.",
    text16: "بيانات الطلب",
    text17: "تاريخ الطلب:",
    text18: " الساعة",
    text19: "معلومات الخدمة",
    text20: "السعر:",
    text21: "السعر لكل:",
    text22: "الفئة:",
    text23: "المورّد:",
    text24: "المورّد:",
    text25: "خدمة داخلية",
    text26: "معلومات الخدمة",
    text27: "لم يُعثر على الخدمة",
    text28: "معلومات مقدّم الطلب",
    text29: "الهاتف:",
    text30: "البريد الإلكتروني:",
    text31: "نوع الوثيقة:",
    text32: "رقم الوثيقة:",
    text33: "إغلاق",
    text34: "رفض",
    text35: "قبول",
    text36: "تأكيد الدفع",
    text37: "رفض الطلب",
    text38: "قبول الطلب",
    text39: "تأكيد دفع مقدّم الطلب",
    text40: "هل تريد بالتأكيد رفض طلب الخدمة؟",
    text41: "تواصل مع مقدّم طلب الخدمة قبل قبول الطلب",
    text42: "بتأكيد دفع مقدّم الطلب، تكتمل العملية",
    text43: "رفض",
    text44: "قبول الطلب",
    text45: "لقد أكّدت الدفع بالفعل",
    text46: "إلغاء",
    text47: "تم التحديث بنجاح.",

    // New labels  

    p1: `اليوم`,
    p2: `الخدمة المطلوبة`,
    p3: `النزيل`,
    p4: `تاريخ الطلب`,
    p5: `لا توجد طلبات خدمات بعد`,
    p6: `لم تُعدّ أي خدمة بعد.`,
    p7: `أعِدّ خدمات وحدة إقامتك ليتمكّن نزلاؤك من إرسال الطلبات`,
    p8: `إعداد خدمة`,
    p9: `استفسار`,
    p10: `تجاهل طلب الخدمة`,
    p11: `هل أنت متأكد؟ ستفقد بيانات الطلب`,
    p12: `تجاهل`,
    p13: `تم حذف طلب الخدمة بنجاح`,
    p14: "ارفع حتى 3 صور لخدمتك",
    p15: "اسحب الصور وأفلِتها لرفعها",
    p16: "...أو اضغط لاختيار الصور من جهازك",
    p17: "اضغط للبحث عن صورة في معرضك"
};
